import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { elementService } from "services";
import { ElementCommon, ElementDto, ElementRequestDto } from "dtos/shard/element.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function ElementEditor(props: {
    user?: UserDto, // Optional dto of the user.
    element?: Partial<ElementDto>,
    preview?: Partial<ElementDto>,
    onPreviewUpdate?: (previewDto: Partial<ElementDto>) => void,
    onClose?: () => void,
    onSave?:(element: ElementDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: ElementCommon = {
        name: props.element?.name ?? "",
        color: props.element?.color ?? "",
    };
    const freshRequestDto: ElementRequestDto = {
        id: props.element?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<ElementDto> = props.preview ? structuredClone(props.preview) : props.element ? structuredClone(props.element) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "element", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.element]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // Elements:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.element ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>
            <div className={`${widgetClasses.row}`}>
                <label>Color</label>
                <input id="color" type="text" value={requestDto.color ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="element"
                service={elementService}
                subject={props.element}
                subjectName={props.element?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}